import { GET_EVENT_CREW } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_EVENT_CREW}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
